module.exports = __webpack_public_path__ + "static/media/farmingWithNoRain-desktop.4cc6fc30.jpg";